import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { connect } from 'formik';
import { Heading } from '@feast-it/pesto';
import { format, addHours } from 'date-fns/fp';
import { isEqual } from 'date-fns';
import compose from 'just-compose';
import { getDuration } from '../../../modules/time';

import * as Styled from './styles';

const generateTimes = (startTime, endTime) => {
  const times = [];
  let duration = 24;

  if (!isEqual(startTime, endTime)) {
    duration = getDuration(startTime, endTime);
  }

  for (let i = 0; i < duration; i += 1) {
    const time = compose(
      addHours(i),
      format('HH:mm')
    )(startTime);

    times.push({
      value: time,
      label: time,
    });
  }

  return times;
};

function TimePicker({ startTime, endTime, name, formik, label, isDisabled }) {
  const { setFieldValue, values } = formik;
  const KEY = name.split('.');
  const value = values[KEY[0]][KEY[1]];

  const handleChange = useCallback(
    input => {
      setFieldValue(name, input.value);
    },
    [name, setFieldValue]
  );

  return (
    <>
      <Heading
        textAlign="center"
        mb={4}
        as="h4"
        variant="headingSmall"
        color="black"
        fontFamily="body"
        fontWeight="heading"
      >
        {label}
      </Heading>

      <Styled.TimePicker>
        <Select
          className="react-select-container"
          classNamePrefix="react-select"
          disabled={isDisabled}
          value={{ label: value }}
          onChange={handleChange}
          isSearchable={false}
          isClearable={false}
          placeholder={false}
          options={generateTimes(startTime, endTime)}
          aria-label={label}
        />
      </Styled.TimePicker>
    </>
  );
}

TimePicker.defaultProps = {
  isDisabled: null,
};

TimePicker.propTypes = {
  startTime: PropTypes.instanceOf(Date),
  endTime: PropTypes.instanceOf(Date),
  name: PropTypes.string.isRequired,
  formik: PropTypes.shape({
    values: PropTypes.shape({}),
    setFieldValue: PropTypes.func,
  }).isRequired,
  label: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
};

export default connect(TimePicker);
